import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses, accessNested } from 'utils/utils';
import s from 'components/bolt/videos/playlist/playlist.sss';
import VideosPlaylistItem from 'components/bolt/videos/playlist/playlistItem';

export default class VideosPlaylist extends Component {
	constructor(props) {
		super(props);
		this.refs = {};
		this.forwardedRefs = {};
	}

	componentDidUpdate(prevProps) {
		const { activeVideo } = this.props;
		if (prevProps.activeVideo !== activeVideo) {
			const firstLoad = !prevProps.activeVideo;
			const activeVideoRef = this.forwardedRefs[activeVideo.key];
			activeVideoRef?.scrollIntoView({ 
				behavior: firstLoad ? 'auto' : 'smooth', // use instant scroll on first load
				block: 'center',
				inline: 'center' 
			});
		}
	}

	render(props) {
		const { videos, changeActiveVideo, activeVideo, hidden } = props;
		const sonyHeaderEnabled = accessNested(Store.get(), 'appData.options.sonyFeatures.sonyHeader', false);
		const isActiveVideoFirst = videos?.length && activeVideo && videos[0].key === activeVideo.key;

		return (
			<div
				ref={ref => this.$scroller = ref}
				class={joinClasses(s.container, hidden && s.hidden, sonyHeaderEnabled && s.sonyHeader)}
			>
				{videos.map((vid) => (
					<VideosPlaylistItem
						ref={ref => this.refs[vid.key] = ref}
						forwardedRef={ref => this.forwardedRefs[vid.key] = ref}
						item={vid}
						onClick={() => changeActiveVideo(vid)}
						activeVideo={activeVideo}
						key={vid.key}
						delayItems={isActiveVideoFirst}
					/>
				))}
			</div>
		);
	}
}
